import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ITopSearchConfig } from '@/new-top-search/top-search.config';

@Component({
	selector: 'app-top-search-filter-items',
	templateUrl: './top-search-filter-items.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopSearchFilterItemsComponent {
	@Input({ required: true }) filters: ITopSearchConfig[] = [];
	@Input() itemMaxWidthPx = 400;
	@Input() variant: 'horizontal' | 'vertical' = 'horizontal';
	@Input() showAdvancedHeader = true;
}
